import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl() {
  return 'v1/users/me/city-code/';
}

/**
 * @param {string} url
 */
function callbackFetch(url) {
  return async () => {
    try {
      // Since 2FA flow is called before pin, need to use pin_token instead of access_token in API calls
      const meta = { isUsingPinToken: true };

      /** @type {import('./typedefs').Response} */
      const res = await fetcher.get(url, { meta });

      return res.data;
    } catch (err) {
      const resp = err?.response?.data;
      errorLogger('ERROR_API', resp?.err_message || err.message);
      throw resp ?? err;
    }
  };
}

export default function fetch() {
  const url = getUrl();

  return {
    cb: callbackFetch(url),
    key: [url],
  };
}
